// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"style-module__modalWrapper___QLB0m","modalBody":"style-module__modalBody___1N_7l"};